
import { Options, Vue, prop } from "vue-class-component";
import {
  FormCompletionSectionKeyV4,
  FormCompletionPanelItemV4
} from "@/domain/entities/BookingV4";

type FormCompletionSectionKeyV4Value = typeof FormCompletionSectionKeyV4[keyof typeof FormCompletionSectionKeyV4];

class Props {
  title = prop<string>({ default: "", type: String });
  items = prop<FormCompletionPanelItemV4[]>({ required: true, type: Array });
}

@Options({
  name: "FormCompletionPanel",
  emits: ["navigate"]
})
export default class FormCompletionPanel extends Vue.with(Props) {
  get panelTitle(): string {
    return this.title || (this.$t("bookingV4.formCompletion.title") as string);
  }

  get documentFields() {
    const documentItem = this.items.find(
      (item) => item.key === FormCompletionSectionKeyV4.SUPPORTING_DOCUMENTS
    );
    const labels = new Set<string>();
    return (documentItem?.fields ?? []).filter((field) => {
      if (labels.has(field.fieldLabel)) return false;
      labels.add(field.fieldLabel);
      return true;
    });
  }

  itemLabelColor(state: string): string {
    return state === "error" ? "text-red-lp-1200" : "text-black-lp-100";
  }

  onItemClick(sectionKey: FormCompletionSectionKeyV4Value) {
    this.$emit("navigate", sectionKey);
  }
}
